"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseType = void 0;
var ReleaseType;
(function (ReleaseType) {
    ReleaseType[ReleaseType["NOT_RELEASED"] = 0] = "NOT_RELEASED";
    ReleaseType[ReleaseType["READY_FOR_RELEASE"] = 1] = "READY_FOR_RELEASE";
    ReleaseType[ReleaseType["RELEASED"] = 2] = "RELEASED";
})(ReleaseType || (exports.ReleaseType = ReleaseType = {}));
